<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    ข้อมูลการติดต่อ
                </div>
                <div class="card-body" style="padding: 20px;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-1"></div>
                        <div class="col-md-1  col-label" style="text-align: left;">
                            <span>Information</span>
                        </div>
                        <div class="col-md-8" style="text-align: left;">
                            <textarea class="form-control fn-required" v-model="information" style="height: 150px;"
                                placeholder="กรุณากรอก Information">
                            </textarea>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-1"></div>
                        <div class="col-md-1  col-label" style="text-align: left;">
                            <span>Email</span>
                        </div>
                        <div class="col-md-8" style="text-align: left;">
                            <input type="text" class="form-control fn-required" v-model="email"
                                placeholder="กรุณากรอกอีเมล">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-1"></div>
                        <div class="col-md-1  col-label" style="text-align: left;">
                            <span>Facebook</span>
                        </div>
                        <div class="col-md-8" style="text-align: left;">
                            <textarea class="form-control fn-required" v-model="facebook"
                                placeholder="กรุณากรอก Facebook">
                            </textarea>
                           
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-1"></div>
                        <div class="col-md-1  col-label" style="text-align: left;">
                            <span>Line Id</span>
                        </div>
                        <div class="col-md-8" style="text-align: left;">

                            <input type="text" class="form-control fn-required" v-model="lineId"
                                placeholder="กรุณากรอก Line Id">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-1"></div>
                        <div class="col-md-1  col-label" style="text-align: left;">
                            <span>Phone</span>
                        </div>
                        <div class="col-md-8" style="text-align: left;">

                            <input type="text" class="form-control fn-required" v-model="phone"
                                placeholder="กรุณากรอก Phone">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-md-4"></div>

                        <div class="col-md-4">
                            <button class="btn btn-primary" @click="update()" style="width: 100%;height: 45px">บันทึก</button>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </section>
</template>

<script>
import ContactService from '../../service/ContactService'
import alertBox from '../../classes/alertBox'


export default {
    name: "ContactManage",
    components: {

    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            information: "",
            email: "",
            facebook: "",
            lineId: "",
            phone: "",
        }
    },
    async created() {
        await this.getContact()

    },
    mounted() {

    },
    methods: {
        async getContact() {
            let response = await ContactService.get()
         
            if (response.status) {
                this.information = response.result.information
                this.email = response.result.email
                this.facebook = response.result.facebook
                this.lineId = response.result.line_id
                this.phone = response.result.phone
            }
        },
        async update() {
            try {

                let response = await ContactService.update(this.information, this.email, this.facebook, this.lineId, this.phone)

                if (response.status) {
                    alertBox.success('save success')
                  
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Manage/Contact.vue